import { apiClient } from '../../../../lib/axios';

export type NotificationTargetType = 'all' | 'client' | 'user' | 'users';

export interface SendNotificationPayload {
  title: string;
  body: string;
  data?: Record<string, string>;
  target: {
    type: NotificationTargetType;
    client_id?: string;
    user_id?: string;
    user_ids?: string[];
  };
}

export interface SendNotificationResult {
  recipients: number;
  success: number;
  failure: number;
}

export interface NotificationUser {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string;
  department_name: string | null;
  region_name: string | null;
  wear_jeopardy_status: string | null;
  connected_status: string | null;
}

export interface GetNotificationUsersParams {
  client_id?: string;
  department?: string[];
  region?: string[];
  depot?: string[];
  job_role?: string[];
  wear_jeopardy?: string[];
  connected_status?: string[];
  at_risk?: string[];
  cardiovascular?: string[];
  activity_status?: string[];
  health_period_start?: string;
  health_period_end?: string;
  search?: string;
}

export interface GetNotificationUsersResponse {
  users: NotificationUser[];
  total: number;
}

export const notificationsApi = {
  send: (payload: SendNotificationPayload) =>
    apiClient.post<{ data: SendNotificationResult }>('/admin/notifications/send', payload).then((r) => r.data),

  getUsers: (params: GetNotificationUsersParams) =>
    apiClient.get<GetNotificationUsersResponse>('/admin/notifications/users', { params }).then((r) => r.data),
};
